import React from "react";
import SvgFrag from "./../../images/frag-axe.svg"
import ImageFrag1 from "./../../images/A2xF1_N011136.jpg"
import ImageFrag2 from "./../../images/A2xF2_N018576.jpg"
import ImageFrag3 from "./../../images/A2xF3_N008102.jpg"
import ImageFrag4 from "./../../images/fragment-manquant.svg"
import ImageFrag5 from "./../../images/A2xF4_N003088.jpg"

const openModal = (ev) => {
    console.log('test');
    var target = ev.target;
    if (target.classList.contains('frag--container')){
    } else if (target.parentNode.classList.contains('frag--container')){
        target = target.parentNode;
    } else if (target.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode;
    } else if (target.parentNode.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode.parentNode;
    }
    target.classList.toggle('show');
}

export default () => (
  <div className="frag--wrapper">
      <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F1</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag1} alt=""/>
                <span>Acteurs jouant une scène. Photographe inconnu. Fonds de la Ville de Québec, AVQ, ca1945.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F2</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag2} alt=""/>
                <span>Concours de natation organisé par l&#39;OTJ. Photographe inconnu, Fonds de la Ville de Québec, AVQ, 1944.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F3</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag3} alt=""/>
                <span>Enregistrement au studio de Radio-Canada- CBV. Photographe inconnu, Fonds de la Ville de Québec, AVQ, ca1944.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F4</span>
        <div className="frag--modal missing">
            <div className="frag--content">
                <ImageFrag4/>
                <span>En présence du premier ministre René Lévesque, réunion d&#39;un groupe communautaire dans une salle du deuxième étage. Source inconnue, ca 1978.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F5</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag5} alt=""/>
                <span>Les Ford bien en vue devant le Palais. Photographe inconnu, Fonds de la Ville de Québec, AVQ, 1951.</span>
            </div>
        </div>
     </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/frag-axe2.js